<template>
  <ImagePreview
    class="carousel-image-preview"
    :images="images"
    :start-position="current"
    @change="onChange"
    @close="onClose"
  >
    <template #header>
      <div class="carousel-image-preview-header">
        <div
          @click="onFindSimilar"
          class="carousel-image-preview-header_find"
        >
          <Icon
            class="carousel-image-preview-button__icon"
            name="icon-image-search-similar"
          />
          Find similar
        </div>
      </div>
      <div class="carousel-image-preview-header_switch">
        <div
          @click="onSwitch('main')"
          :class="{ 'active': active === 'products' }"
          class="carousel-image-preview-header_switch__item"
        >
          Main Images
        </div>
        <div
          v-if="props.stylesLength > 0"
          @click="onSwitch('variant')"
          :class="{ 'active': active === 'styles' }"
          class="carousel-image-preview-header_switch__item"
        >
          Variant Images
        </div>
        <div
          @click="onSwitch('desc')"
          :class="{ 'active': active === 'desc' }"
          class="carousel-image-preview-header_switch__item"
        >
          Description Images
        </div>
      </div>
    </template>
    <template #toolbar>
      <div class="carousel-image-preview-toolbar">
        <div class="carousel-image-preview-progress">
          <div
            class="carousel-image-preview-progress__line"
            :style="{
              width: `${(index + 1) / length * 100}%`
            }"
          />
        </div>
        <div class="carousel-image-preview-step">
          {{ index + 1 }} / {{ length }}
        </div>
        <div
          v-if="active === 'styles'"
          class="carousel-image-preview-attr"
        >
          {{ variantImages[index].valueTrans }}
        </div>
        <div class="carousel-image-preview-thumbs">
          <div
            v-for="(item, i) in thumbs"
            :key="i"
            @click="thumbsClick(i)"
            :class="{ 'active': i === index }"
            class="carousel-image-preview-thumbs__item"
          >
            <img
              :src="item"
              alt=""
            >
          </div>
        </div>
      </div>
    </template>
  </ImagePreview>
</template>

<script setup>
import { Icon } from '@/components/Icon'
import { ImagePreview } from '@/components/ImagePreview'

const props = defineProps({
  images: {
    type: Array,
    required: true
  },
  productsLength: {
    type: Number,
    required: true
  },
  stylesLength: {
    type: Number,
    required: true
  },
  descImages: {
    type: Array,
    default: () => []
  },
  index: {
    type: Number,
    required: true
  },
  variantImages: {
    type: Array,
    default: () => []
  }
})
const emit = defineEmits(['close', 'findSimilar'])

const current = ref(props.index)

watch(() => props.index, (index) => {
  current.value = index
})

const active = computed(() => {
  let tab = ''
  if (current.value < props.productsLength) {
    tab = 'products'
  } else if (current.value < props.productsLength + props.stylesLength) {
    tab = 'styles'
  } else {
    tab = 'desc'
  }
  return tab
})
/**
 * 展示的索引和长度，需要区分当前处于 images 还是 styles 还是 desc
 */
const index = computed(() => {
  if (active.value === 'products') {
    return current.value
  } else if (active.value === 'styles') {
    return current.value - props.productsLength
  } else {
    return current.value - props.productsLength - props.stylesLength
  }
})
const length = computed(() => {
  if (active.value === 'products') {
    return props.productsLength
  } else if (active.value === 'styles') {
    return props.stylesLength
  } else {
    return props.descImages.length
  }
})

const thumbs = computed(() => {
  if (active.value === 'products') {
    return props.images.slice(0, props.productsLength)
  } else if (active.value === 'styles') {
    return props.images.slice(props.productsLength, props.productsLength + props.stylesLength)
  } else {
    return props.descImages
  }
})

const onChange = (index) => {
  current.value = index
}

const onClose = () => {
  emit('close', current.value)
}

const onSwitch = (type) => {
  if (type === 'main') {
    current.value = 0
  }
  if (type === 'variant') {
    current.value = props.productsLength
  }

  if (type === 'desc') {
    current.value = props.productsLength + props.stylesLength
  }
}

const thumbsClick = (i) => {
  if (active.value === 'products') {
    current.value = i
  } else if (active.value === 'styles') {
    current.value = i + props.productsLength
  } else {
    current.value = i + props.productsLength + props.stylesLength
  }
  console.log('current.value: ', current.value)
}

const onFindSimilar = () => {
  emit('findSimilar', props.images[current.value])
}
</script>

<style lang="less">
.carousel-image-preview {
  &-header {
    position: absolute;
    top: 12px;
    right: 12px;
    &_find {
      width: 130px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      color: white;
      font-size: 14px;
      font-family: mon-600;
      border: 1px solid #ebf1f5;
      border-radius: 16px;
    }

    &_switch {
      width: 337px;
      height: 28px;
      border-radius: 12px;
      background-color: #232323;
      display: flex;
      align-items: center;
      gap: 2px;
      margin-bottom: 24px;
      &__item {
        padding: 4px 8px;
        height: 24px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #B2B7C2;
        font-size: 12px;
        font-family: mon-500;
        white-space: nowrap;
        &.active {
          background-color: #141414;
          color: white;
        }
      }
    }
  }

  &-toolbar {
    position: relative;
    padding: 12px 16px;
    width: 100%;
  }

  &-progress {
    height: 4px;
    width: 100%;
    border-radius: 2px;
    background-color: #494D51;

    &__line {
      height: 100%;
      width: 0%;
      border-radius: inherit;
      background-color: #969AA3;
      transition: all .3s ease-in-out;
    }
  }

  &-step {
    margin-top: 24px;
    color: #B2B7C2;
    font-family: mon-500;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  }

  &-attr {
    margin-top: 14px;
    color: white;
    line-height: 16px;
    text-align: center;
    font-size: 12px;
    font-family: mon-500;
  }

  &-thumbs {
    margin-top: 12px;
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding-left: 4px;
    overflow-x: scroll;
    overflow-y: hidden;

    &__item {
      flex-shrink: 0;
      width: 52px;
      height: 52px;
      border: 1px solid #494D51;
      border-radius: 4px;
      &.active {
        outline: 2px solid #969AA3;
        outline-offset: 1px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 4px;
      }
    }
  }
}
</style>
